import React from 'react'
import banner from '../../assets/images/newBanner.png'

const Banner = ({ title, description }) => {
    return (
        <div className='banner'>
            <img src={banner} alt='' />
            <div className='slogan'>
                <div><strong className='f40 fw500'>{title}</strong></div>
                <div className='mt-2'><span className='f20 fw500 color3'>{description}</span></div>
            </div>
        </div>
    )
}

export default Banner
